// Keep the complete local destination through Slack OAuth, without allowing off-site redirects.
export function loginDestination(state: unknown): string {
  const from = (state as { from?: { pathname?: string; search?: string; hash?: string } } | null)?.from
  const path = from?.pathname
  if (!path?.startsWith('/') || path.startsWith('//') || /[\\\r\n]/.test(path)) return '/dashboard'
  return path + (from?.search?.startsWith('?') ? from.search : '') + (from?.hash?.startsWith('#') ? from.hash : '')
}
